export default {
    classType: 'components',

    init() {
        this.elTitle = this.el.querySelector('.accordion-title');
        this.elContent = this.el.querySelector('.accordion-content');
        this.elIcon = this.el.querySelector('.accordion-title .fa');
        this.elTitle.addEventListener('click', this.toggleAccordion.bind(this));
    },

    toggleAccordion() {
        const isOpened = this.el.classList.toggle('opened');
        this.elIcon.classList.replace(
            'fa-' + (isOpened ? 'plus' : 'minus'),
            'fa-' + (isOpened ? 'minus' : 'plus')
        );
    },
};
